// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sisY","colMin":"styles_colMin__3A_E3"};